import React, { useEffect, useState } from 'react';
import api from '../../../../config/axios';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';

import MaquininhaModal from './modals/Maquininha';

import { FaPlus, FaEdit, FaFilter, FaTrashAlt, FaArrowLeft } from 'react-icons/fa';
import Paginacao from '../../../../components/utils/paginacao';

const Maquininhas = () => {
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [maquininhas, setMaquininhas] = useState([]);
  const [filtroApelido, setFiltroApelido] = useState('');

  const [selectedMaquininha, setSelectedMaquininha] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRegistros, setTotalRegistros] = useState(0);
  const limit = 10;

  const fetchMaquininhas = async (page) => {
    try {
      Swal.fire({
        title: 'Carregando...',
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      const params = {
        page: page,
        limit: limit,
        apelido: filtroApelido
      };

      const response = await api.get('/maquinas-pagamento', { params });

      setMaquininhas(response.data.records || []);
      setTotalPages((Math.ceil(response.data.totalRegistros / limit)) || 1);
      setTotalRegistros(response.data.totalRegistros || 0);
      setError(null);
    } catch (err) {
      setError('Erro ao carregar a lista de máquininhas.');
    } finally {
      Swal.close();
    }
  };

  useEffect(() => {
    fetchMaquininhas(currentPage);
  }, [currentPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleAddMaquininha = () => {
    setSelectedMaquininha(null);
    setIsModalOpen(true);
  };

  const handleEditMaquininha = (maquininha) => {
    setSelectedMaquininha(maquininha);
    setIsModalOpen(true);
  };

  const handleFiltrar = () => {
    setCurrentPage(1);
    fetchMaquininhas(1);
  };

  const handleLimparFiltros = () => {
    setFiltroApelido('');
  };

  const handleVoltar = () => {
    navigate('/financeiro/cadastros');
  };

  const handleDeleteMaquininha = (maquininha) => {
    Swal.fire({
      title: 'Aviso',
      text: 'Deseja deletar esta máquininha?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim, confirmar!',
      cancelButtonText: 'Cancelar'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await api.delete(`/maquinas-pagamento/${maquininha.id}`);

          fetchMaquininhas(currentPage);
          Swal.fire('Sucesso', 'Máquininha deletada com sucesso!', 'success');
        }
        catch (error) {
          Swal.fire('Erro', `${error.response.data.message}`, 'error');
        }
      }
    });
  };

  return (
    <div className="container-fluid">
      <div className="card">
        <div className="card-body">
          <div className="row mt-3">
            <div className="col-12 d-flex align-items-center mb-3">
              <button
                className="btn btn-outline-secondary me-3"
                onClick={handleVoltar}
              >
                <FaArrowLeft />
              </button>
              <h4 className="fw-bold mb-0">Máquininhas</h4>
            </div>
          </div>
          <div className="row mt-3 mb-3">
            <div className="col-md-6 col-12">
              <button className="btn btn-outline-primary" onClick={handleAddMaquininha}>
                <FaPlus /> Adicionar Máquininha
              </button>
            </div>
          </div>

          <div className="row mt-4 mb-4">
            <div className="col-lg-3 col-12">
              <label className="form-label fw-bold">Apelido</label>
              <input
                type="text"
                autoComplete="off"
                placeholder="Digite o apelido da máquininha"
                value={filtroApelido}
                className="form-control"
                onChange={(e) => setFiltroApelido(e.target.value)}
              />
            </div>
            <div className="col-lg-9 col-12 mt-lg-0 mt-3 d-flex align-items-end">
              <div className="d-flex gap-2 w-100 justify-content-end">
                <button
                  className="btn btn-outline-secondary"
                  onClick={handleLimparFiltros}
                >
                  Limpar
                </button>
                <button
                  className="btn btn-custom-primary"
                  onClick={handleFiltrar}
                >
                  <FaFilter /> Filtrar
                </button>
              </div>
            </div>
          </div>

          {error ? (
            <p className="error-message">{error}</p>
          ) : (
            <div className="table-responsive">
              <table className="table table-striped">
                <thead className="table-custom-primary">
                  <tr>
                    <th>Apelido</th>
                    <th>Número Serial</th>
                    <th>Status</th>
                    <th className="text-center">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {maquininhas.length === 0 ? (
                    <tr>
                      <td colSpan="4" className="text-center">Nenhuma máquininha encontrada</td>
                    </tr>
                  ) : (
                    maquininhas.map((maquininha) => (
                      <tr key={maquininha.id}>
                        <td className="text-nowrap">{maquininha.apelido}</td>
                        <td className="text-nowrap">{maquininha.serial}</td>
                        <td className="text-nowrap">
                          <span className={`badge ${maquininha.status === 'ativo' ? 'bg-success' : 'bg-danger'}`}>
                            {maquininha.status.charAt(0).toUpperCase() + maquininha.status.slice(1)}
                          </span>
                        </td>
                        <td className="text-center">
                          <button
                            className="btn btn-custom-secondary btn-sm"
                            onClick={() => handleEditMaquininha(maquininha)}
                          >
                            <FaEdit />
                          </button>
                          <button
                            className="btn btn-custom-secondary btn-sm ms-3"
                            onClick={() => handleDeleteMaquininha(maquininha)}
                          >
                            <FaTrashAlt />
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          )}

          <div className="d-flex justify-content-between align-items-center mt-4">
            <div className="mb-3">
              <span>
                Total de registros: <strong>{totalRegistros}</strong>
              </span>
            </div>
            <Paginacao
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          </div>
        </div>
      </div>

      {isModalOpen && (
        <MaquininhaModal
          onClose={() => setIsModalOpen(false)}
          maquininha={selectedMaquininha}
          onMaquininhaAtualizada={() => fetchMaquininhas(currentPage)}
        />
      )}
    </div>
  );
};

export default Maquininhas; 